// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media all and (min-width: 0px) and (max-width: 600px) {
  .modal #SaleInformation_component {
    display: block;
    position: relative;
  }
}

#SaleInformation_component {
  background-color: #F4F4F4;
  width: 30%;
  padding: 0 20px;
  padding-top: 15px;
  position: fixed;
  right: 0;
  height: 100%;
  overflow: auto;
  padding-bottom: 100px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
#SaleInformation_component .workflow-activities {
  padding-bottom: 50px !important;
}
#SaleInformation_component .quality-check-box {
  margin: 20px 0;
}
#SaleInformation_component .modifiedDesign {
  color: red;
}
#SaleInformation_component img {
  width: 100px;
}
@media all and (min-width: 0px) and (max-width: 600px) {
  #SaleInformation_component {
    display: none;
    height: 30%;
    top: 70%;
    width: 100%;
  }
}
#SaleInformation_component h2 {
  text-align: center;
  padding: 6px 2px;
}
#SaleInformation_component .accordion-item .accordion-header {
  text-align: center;
  padding: 0px 0px;
}
#SaleInformation_component .accordion-item .accordion-header .accordion-button {
  background-color: white;
  color: black;
  text-align: left;
  width: 100%;
  padding: 5px 15px;
  display: block;
  border-bottom: 1px solid #dbb7bb;
}
#SaleInformation_component .accordion-item .accordion-header .accordion-button:focus {
  outline: none;
  box-shadow: none;
}
#SaleInformation_component .accordion-item .accordion-header .accordion-button.collapsed {
  border-bottom: 1px solid transparent;
}
#SaleInformation_component .accordion-item .accordion-header .accordion-button::after {
  display: inline-block;
  float: right;
}
#SaleInformation_component .choose_message {
  margin-top: 50px;
  text-align: center;
  font-size: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#SaleInformation_component .choose_message span {
  font-size: 40px;
}
#SaleInformation_component .link_to_detail a {
  background-color: transparent;
  display: inline-block;
  color: #9A9696;
  border: none;
  text-align: center;
  font-size: 13px;
  line-height: 8px;
  padding: 0px 10px;
  text-decoration: none;
}
#SaleInformation_component .link_to_detail a img {
  width: 40px;
}
#SaleInformation_component .details {
  padding: 6px 6px;
}
#SaleInformation_component .costs_information {
  max-height: 35vh;
  overflow-y: scroll;
}

#SaleInformation_component .sale_information_subcontainer .row,
#SaleInformation_component .sale_row .row,
#SalesList_component .sale_information_subcontainer .row,
#SalesList_component .sale_row .row,
#PostSalesList_component .sale_information_subcontainer .row,
#PostSalesList_component .sale_row .row {
  border-bottom: #ddd solid 1px;
}
#SaleInformation_component .sale_information_subcontainer .row:last-child,
#SaleInformation_component .sale_row .row:last-child,
#SalesList_component .sale_information_subcontainer .row:last-child,
#SalesList_component .sale_row .row:last-child,
#PostSalesList_component .sale_information_subcontainer .row:last-child,
#PostSalesList_component .sale_row .row:last-child {
  border-bottom: none;
}
#SaleInformation_component .sale_information_subcontainer .grid_title,
#SaleInformation_component .sale_row .grid_title,
#SalesList_component .sale_information_subcontainer .grid_title,
#SalesList_component .sale_row .grid_title,
#PostSalesList_component .sale_information_subcontainer .grid_title,
#PostSalesList_component .sale_row .grid_title {
  font-weight: bold;
}
#SaleInformation_component .sale_information_subcontainer .pending,
#SaleInformation_component .sale_row .pending,
#SalesList_component .sale_information_subcontainer .pending,
#SalesList_component .sale_row .pending,
#PostSalesList_component .sale_information_subcontainer .pending,
#PostSalesList_component .sale_row .pending {
  color: orange;
}
#SaleInformation_component .sale_information_subcontainer .ready,
#SaleInformation_component .sale_row .ready,
#SalesList_component .sale_information_subcontainer .ready,
#SalesList_component .sale_row .ready,
#PostSalesList_component .sale_information_subcontainer .ready,
#PostSalesList_component .sale_row .ready {
  color: green;
}
#SaleInformation_component .sale_information_subcontainer .internal-transit,
#SaleInformation_component .sale_row .internal-transit,
#SalesList_component .sale_information_subcontainer .internal-transit,
#SalesList_component .sale_row .internal-transit,
#PostSalesList_component .sale_information_subcontainer .internal-transit,
#PostSalesList_component .sale_row .internal-transit {
  color: purple;
}
#SaleInformation_component .sale_information_subcontainer .cancelled,
#SaleInformation_component .sale_row .cancelled,
#SalesList_component .sale_information_subcontainer .cancelled,
#SalesList_component .sale_row .cancelled,
#PostSalesList_component .sale_information_subcontainer .cancelled,
#PostSalesList_component .sale_row .cancelled {
  color: red;
}
#SaleInformation_component .sale_information_subcontainer .collected-shipped,
#SaleInformation_component .sale_row .collected-shipped,
#SalesList_component .sale_information_subcontainer .collected-shipped,
#SalesList_component .sale_row .collected-shipped,
#PostSalesList_component .sale_information_subcontainer .collected-shipped,
#PostSalesList_component .sale_row .collected-shipped {
  color: #3d7223;
}

#SaleInformation_component .payment_information {
  margin-top: 20px;
  border: 1px solid #FFB7B2;
}
#SaleInformation_component .payment_information h2 {
  background-color: #FFB7B2;
}

#SaleInformation_component .products_information {
  margin-top: 20px;
  border: 1px solid #FFDAC1;
}
#SaleInformation_component .products_information h2 {
  background-color: #FFDAC1;
}
#SaleInformation_component .products_information .diamond {
  padding: 4px 6px;
  width: 50%;
}
#SaleInformation_component .products_information .setting {
  padding: 4px 6px;
  width: 50%;
}

#SaleInformation_component .history {
  margin-top: 20px;
  border: 1px solid #E2F0CB;
}
#SaleInformation_component .history h2 {
  background-color: #E2F0CB;
}

#SaleInformation_component .manufacturing_information {
  margin-top: 20px;
  border: 1px solid #B5EAD7;
}
#SaleInformation_component .manufacturing_information h2 {
  background-color: #B5EAD7;
}

#SaleInformation_component .discussion {
  margin-top: 20px;
  border: 1px solid #C7CEEA;
}
#SaleInformation_component .discussion h2 {
  background-color: #C7CEEA;
}

#SaleInformation_component .information .workflow-activity-card {
  padding: 10px;
  border: 1px solid gray;
  margin: 20px 0;
}
#SaleInformation_component .information .workflow-activity-card .edit-link {
  cursor: pointer;
  color: #5673f8;
}
#SaleInformation_component .information .workflow-activity-subelement {
  margin-left: 20px;
}
#SaleInformation_component .information .details-top-heading {
  display: block;
  width: 100%;
  color: #524C58;
}
#SaleInformation_component .information .details-top-heading .order-no-section {
  display: inline-block;
}
#SaleInformation_component .information .details-top-heading .order-no-section span {
  color: #524C58;
  font-size: 36px;
  font-weight: bold;
  vertical-align: bottom;
}
@media only screen and (max-width: 1440px) {
  #SaleInformation_component .information .details-top-heading .order-no-section h1 {
    font-size: 23px;
  }
  #SaleInformation_component .information .details-top-heading .order-no-section h1 span {
    font-size: 29px;
  }
}
#SaleInformation_component .information .details-top-heading .order-action-section {
  display: flex;
  margin-bottom: 10px;
}
#SaleInformation_component .information .details-top-heading .order-action-section .link_to_detail {
  float: right;
  text-decoration: underline;
  display: inline-block;
}
#SaleInformation_component .information .details-top-heading .order-action-section .link_to_edit,
#SaleInformation_component .information .details-top-heading .order-action-section .link-to-workflow,
#SaleInformation_component .information .details-top-heading .order-action-section .link-to-return {
  display: inline-block;
}
#SaleInformation_component .information .details-top-heading .order-action-section .link_to_edit .btn,
#SaleInformation_component .information .details-top-heading .order-action-section .link-to-workflow .btn,
#SaleInformation_component .information .details-top-heading .order-action-section .link-to-return .btn {
  background-color: transparent;
  display: inline-block;
  color: #9A9696;
  border: none;
  text-align: center;
  font-size: 13px;
  line-height: 8px;
  padding: 0px 10px;
  text-decoration: none;
}
#SaleInformation_component .information .details-top-heading .order-action-section .link_to_edit .btn img,
#SaleInformation_component .information .details-top-heading .order-action-section .link-to-workflow .btn img,
#SaleInformation_component .information .details-top-heading .order-action-section .link-to-return .btn img {
  width: 40px;
}
#SaleInformation_component .information .details-top-heading .worflow-action-section {
  display: flex;
  margin-bottom: 10px;
}
#SaleInformation_component .information .details-top-heading .worflow-action-section .link-to-return {
  display: inline-block;
}
#SaleInformation_component .information .details-top-heading .worflow-action-section .link-to-return .btn {
  background-color: transparent;
  display: inline-block;
  color: #9A9696;
  border: none;
  text-align: center;
  font-size: 13px;
  line-height: 8px;
  padding: 0px 10px;
  text-decoration: none;
}
#SaleInformation_component .information .details-top-heading .worflow-action-section .link-to-return .btn img {
  width: 40px;
}
#SaleInformation_component .information .sales-details-card {
  background-color: white;
  margin-bottom: 10px;
  border-radius: 15px;
  padding-bottom: 10px;
}
#SaleInformation_component .information .sales-details-card h2 {
  text-transform: uppercase;
  text-align: left !important;
  background-color: #727272;
  color: white;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  padding: 5px 15px;
  font-size: 18px;
}
#SaleInformation_component .information .sales-details-card .border-right {
  border-right: 1px solid #ddd;
}
#SaleInformation_component .information .sales-details-card .border-right:last-child {
  border-right: none;
}

#SaleInformation_component .modified_value {
  color: orange;
}

#SaleInformation_component .workflow-activity-card .inTransit {
  color: purple;
}
#SaleInformation_component .workflow-activity-card .completed {
  color: green;
}
#SaleInformation_component .workflow-activity-card .cancelled {
  color: red;
}
#SaleInformation_component .general_information .saleSubWorkflowHeading {
  text-transform: uppercase;
  text-align: left !important;
  background-color: #727272;
  color: white;
  border-radius: 10px;
  padding: 5px 15px;
  font-size: 18px;
  display: block;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/css/sales/sale_information.scss"],"names":[],"mappings":"AAWQ;EADJ;IAEQ,cAAA;IACA,kBAAA;EATV;AACF;;AAaA;EAaI,yBAAA;EAMA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,4BAAA;EACA,+BAAA;AA3BJ;AAAI;EACI,+BAAA;AAER;AACI;EACI,cAAA;AACR;AAEI;EACI,UAAA;AAAR;AAKI;EACI,YAAA;AAHR;AAiBI;EA9BJ;IA+BQ,aAAA;IACA,WAAA;IACA,QAAA;IACA,WAAA;EAdN;AACF;AAgBI;EACI,kBAAA;EACA,gBAAA;AAdR;AAkBQ;EACI,kBAAA;EACA,gBAAA;AAhBZ;AAkBY;EACI,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;AAhBhB;AAkBgB;EACI,aAAA;EACA,gBAAA;AAhBpB;AAmBgB;EACI,oCAAA;AAjBpB;AAoBgB;EACI,qBAAA;EACA,YAAA;AAlBpB;AA0BI;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAxBR;AA0BQ;EACI,eAAA;AAxBZ;AAgCQ;EACI,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AA9BZ;AAgCY;EACI,WAAA;AA9BhB;AAmCI;EACI,gBAAA;AAjCR;AAoCI;EACI,gBAAA;EACA,kBAAA;AAlCR;;AA4CQ;;;;;;EACI,6BAAA;AApCZ;AAsCY;;;;;;EACI,mBAAA;AA/BhB;AAmCQ;;;;;;EACI,iBAAA;AA5BZ;AA+BQ;;;;;;EACI,aAAA;AAxBZ;AA2BQ;;;;;;EACI,YAAA;AApBZ;AAuBQ;;;;;;EACI,aAAA;AAhBZ;AAmBQ;;;;;;EACI,UAAA;AAZZ;AAeQ;;;;;;EACI,cAAA;AARZ;;AAcI;EACI,gBAAA;EAMA,yBAAA;AAhBR;AAYQ;EACI,yBAtLE;AA4Kd;;AAkBI;EACI,gBAAA;EAMA,yBAAA;AApBR;AAgBQ;EACI,yBAjMG;AAmLf;AAmBQ;EACI,gBAAA;EACA,UAAA;AAjBZ;AAoBQ;EACI,gBAAA;EACA,UAAA;AAlBZ;;AAwBI;EACI,gBAAA;EAMA,yBAAA;AA1BR;AAsBQ;EACI,yBAtNE;AAkMd;;AA4BI;EACI,gBAAA;EAMA,yBAAA;AA9BR;AA0BQ;EACI,yBAjOE;AAyMd;;AAgCI;EACI,gBAAA;EAMA,yBAAA;AAlCR;AA8BQ;EACI,yBA5OI;AAgNhB;;AAqCQ;EACI,aAAA;EACA,sBAAA;EACA,cAAA;AAlCZ;AAoCY;EACI,eAAA;EACA,cAAA;AAlChB;AAsCQ;EACI,iBAAA;AApCZ;AAuCQ;EACI,cAAA;EACA,WAAA;EACA,cAAA;AArCZ;AAuCY;EACI,qBAAA;AArChB;AAuCgB;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AArCpB;AAwCgB;EACI;IACI,eAAA;EAtCtB;EAwCsB;IACI,eAAA;EAtC1B;AACF;AA2CY;EACI,aAAA;EACA,mBAAA;AAzChB;AA2CgB;EACI,YAAA;EACA,0BAAA;EACA,qBAAA;AAzCpB;AA4CgB;;;EAGI,qBAAA;AA1CpB;AA4CoB;;;EACI,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAxCxB;AA0CwB;;;EACI,WAAA;AAtC5B;AA4CY;EACI,aAAA;EACA,mBAAA;AA1ChB;AA4CgB;EACI,qBAAA;AA1CpB;AA4CoB;EACI,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AA1CxB;AA4CwB;EACI,WAAA;AA1C5B;AAiDQ;EACI,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AA/CZ;AAiDY;EACI,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AA/ChB;AAkDY;EACI,4BAAA;AAhDhB;AAkDgB;EACI,kBAAA;AAhDpB;;AAwDI;EACI,aAAA;AArDR;;AA2DQ;EACI,aAAA;AAxDZ;AA2DQ;EACI,YAAA;AAzDZ;AA4DQ;EACI,UAAA;AA1DZ;AA+DQ;EACI,yBAAA;EACA,2BAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AA7DZ","sourcesContent":["$color_red_1: #FF9AA2;\n$color_red_2: #FFB7B2;\n$color_orange: #FFDAC1;\n$color_grass: #E2F0CB;\n$color_green: #B5EAD7;\n$color_purlple: #C7CEEA;\n$blue_link: #5673f8;\n$font_size_content: 13px;\n\n.modal {\n    #SaleInformation_component {\n        @media all and (min-width: 0px) and (max-width: 600px) {\n            display: block;\n            position: relative;\n        }\n    }\n}\n\n#SaleInformation_component {\n    .workflow-activities {\n        padding-bottom: 50px !important;\n    }\n\n    .quality-check-box {\n        margin: 20px 0;\n    }\n\n    .modifiedDesign {\n        color: red;\n    }\n\n    background-color: #F4F4F4;\n\n    img {\n        width: 100px;\n    }\n\n    width: 30%;\n    padding: 0 20px;\n    padding-top: 15px;\n    position: fixed;\n    right: 0;\n    height: 100%;\n    overflow: auto;\n    padding-bottom: 100px;\n    border-top-left-radius: 15px;\n    border-bottom-left-radius: 15px;\n\n    @media all and (min-width:0px) and (max-width: 600px) {\n        display: none;\n        height: 30%;\n        top: 70%;\n        width: 100%;\n    }\n\n    h2 {\n        text-align: center;\n        padding: 6px 2px;\n    }\n\n    .accordion-item {\n        .accordion-header {\n            text-align: center;\n            padding: 0px 0px;\n\n            .accordion-button {\n                background-color: white;\n                color: black;\n                text-align: left;\n                width: 100%;\n                padding: 5px 15px;\n                display: block;\n                border-bottom: 1px solid #dbb7bb;\n\n                &:focus {\n                    outline: none;\n                    box-shadow: none;\n                }\n\n                &.collapsed {\n                    border-bottom: 1px solid transparent;\n                }\n\n                &::after {\n                    display: inline-block;\n                    float: right;\n                }\n            }\n        }\n\n        .accordion-collapse {}\n    }\n\n    .choose_message {\n        margin-top: 50px;\n        text-align: center;\n        font-size: 30px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n\n        span {\n            font-size: 40px;\n        }\n    }\n\n    .link_to_detail {\n\n        // float: right;\n        //margin-right: 5px;\n        a {\n            background-color: transparent;\n            display: inline-block;\n            color: #9A9696;\n            border: none;\n            text-align: center;\n            font-size: 13px;\n            line-height: 8px;\n            padding: 0px 10px;\n            text-decoration: none;\n\n            img {\n                width: 40px;\n            }\n        }\n    }\n\n    .details {\n        padding: 6px 6px;\n    }\n\n    .costs_information {\n        max-height: 35vh;\n        overflow-y: scroll;\n    }\n}\n\n#SaleInformation_component,\n#SalesList_component,\n#PostSalesList_component {\n\n    .sale_information_subcontainer,\n    .sale_row {\n        .row {\n            border-bottom: #ddd solid 1px;\n\n            &:last-child {\n                border-bottom: none;\n            }\n        }\n\n        .grid_title {\n            font-weight: bold;\n        }\n\n        .pending {\n            color: orange;\n        }\n\n        .ready {\n            color: green;\n        }\n\n        .internal-transit {\n            color: purple;\n        }\n\n        .cancelled {\n            color: red;\n        }\n\n        .collected-shipped {\n            color: #3d7223;\n        }\n    }\n}\n\n#SaleInformation_component {\n    .payment_information {\n        margin-top: 20px;\n\n        h2 {\n            background-color: $color_red_2;\n        }\n\n        border: 1px solid $color_red_2;\n    }\n}\n\n#SaleInformation_component {\n    .products_information {\n        margin-top: 20px;\n\n        h2 {\n            background-color: $color_orange;\n        }\n\n        border: 1px solid $color_orange;\n\n        .diamond {\n            padding: 4px 6px;\n            width: 50%;\n        }\n\n        .setting {\n            padding: 4px 6px;\n            width: 50%;\n        }\n    }\n}\n\n#SaleInformation_component {\n    .history {\n        margin-top: 20px;\n\n        h2 {\n            background-color: $color_grass;\n        }\n\n        border: 1px solid $color_grass;\n    }\n}\n\n#SaleInformation_component {\n    .manufacturing_information {\n        margin-top: 20px;\n\n        h2 {\n            background-color: $color_green;\n        }\n\n        border: 1px solid $color_green;\n    }\n}\n\n#SaleInformation_component {\n    .discussion {\n        margin-top: 20px;\n\n        h2 {\n            background-color: $color_purlple;\n        }\n\n        border: 1px solid $color_purlple;\n    }\n}\n\n#SaleInformation_component {\n    .information {\n        .workflow-activity-card {\n            padding: 10px;\n            border: 1px solid gray;\n            margin: 20px 0;\n\n            .edit-link {\n                cursor: pointer;\n                color: #5673f8;\n            }\n        }\n\n        .workflow-activity-subelement {\n            margin-left: 20px;\n        }\n\n        .details-top-heading {\n            display: block;\n            width: 100%;\n            color: #524C58;\n\n            .order-no-section {\n                display: inline-block;\n\n                span {\n                    color: #524C58;\n                    font-size: 36px;\n                    font-weight: bold;\n                    vertical-align: bottom;\n                }\n\n                @media only screen and (max-width: 1440px) {\n                    h1 {\n                        font-size: 23px;\n\n                        span {\n                            font-size: 29px;\n                        }\n                    }\n                }\n            }\n\n            .order-action-section {\n                display: flex;\n                margin-bottom: 10px;\n\n                .link_to_detail {\n                    float: right;\n                    text-decoration: underline;\n                    display: inline-block;\n                }\n\n                .link_to_edit,\n                .link-to-workflow,\n                .link-to-return {\n                    display: inline-block;\n\n                    .btn {\n                        background-color: transparent;\n                        display: inline-block;\n                        color: #9A9696;\n                        border: none;\n                        text-align: center;\n                        font-size: 13px;\n                        line-height: 8px;\n                        padding: 0px 10px;\n                        text-decoration: none;\n\n                        img {\n                            width: 40px;\n                        }\n                    }\n                }\n            }\n\n            .worflow-action-section {\n                display: flex;\n                margin-bottom: 10px;\n\n                .link-to-return {\n                    display: inline-block;\n\n                    .btn {\n                        background-color: transparent;\n                        display: inline-block;\n                        color: #9A9696;\n                        border: none;\n                        text-align: center;\n                        font-size: 13px;\n                        line-height: 8px;\n                        padding: 0px 10px;\n                        text-decoration: none;\n\n                        img {\n                            width: 40px;\n                        }\n                    }\n                }\n            }\n        }\n\n        .sales-details-card {\n            background-color: white;\n            margin-bottom: 10px;\n            border-radius: 15px;\n            padding-bottom: 10px;\n\n            h2 {\n                text-transform: uppercase;\n                text-align: left !important;\n                background-color: #727272;\n                color: white;\n                border-top-left-radius: 15px;\n                border-top-right-radius: 15px;\n                padding: 5px 15px;\n                font-size: 18px;\n            }\n\n            .border-right {\n                border-right: 1px solid #ddd;\n\n                &:last-child {\n                    border-right: none;\n                }\n            }\n        }\n    }\n}\n\n#SaleInformation_component {\n    .modified_value {\n        color: orange;\n    }\n}\n\n#SaleInformation_component {\n    .workflow-activity-card {\n        .inTransit {\n            color: purple;\n        }\n\n        .completed {\n            color: green;\n        }\n\n        .cancelled {\n            color: red;\n        }\n    }\n\n    .general_information {\n        .saleSubWorkflowHeading {\n            text-transform: uppercase;\n            text-align: left !important;\n            background-color: #727272;\n            color: white;\n            border-radius: 10px;\n            padding: 5px 15px;\n            font-size: 18px;\n            display: block;\n            margin-bottom: 10px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
